<template>
  <el-loading-wrapper
      v-bc-infinite-scroll="scrollConfig"
      @scrollEnd="atScrollEnd"
      tag="div"
      style="min-height: 50px;"
      :loading="isLoading" >
      <template
        v-if="!isLoading && isLastPage">
        <slot />
      </template>
  </el-loading-wrapper>
</template>

<script>
import BCInfiniteScroll from '#/notes/components/directives/BCInfiniteScroll'

export default {
  name: 'bcInfiniteScrollPagination',
  directives: {
    'bc-infinite-scroll': BCInfiniteScroll
  },
  props: {
    /**
     * Expects a DOM query selector
     * for a scrollable element
     */
    scrollableElementSelector: {
      type: String
    },
    currentPage: {
      type: Number,
      default: 1
    },
    nextPage: {
      type: Number,
      default: null
    },
    isLoading: [Boolean]
  },
  computed: {
    scrollConfig () {
      return {
        target: this.scrollableElementSelector
      }
    },
    isLastPage () {
      return this.nextPage === null
    }
  },
  methods: {
    atScrollEnd () {
      if (this.isLoading) return
      if (this.isLastPage) return
      const nextPage = this.currentPage + 1

      this.$emit('scrollEnd', {
        currentPage: nextPage
      })
    }
  }

}
</script>
